/**
 * PR 9.2g: 驱动词溯源 chip —— 点击拉 /api/v2/brands/{id}/driver-sources,
 * popover 列 3-5 条真实原文 URL;空 → fallback `/complaints?brand=<id>`(Codex 锁 B)。
 *
 * 不改现有 KeywordChip(别处复用),BrandDetail 正/负驱动专用。
 */
import { useState } from 'react';
import { List, Popover, Spin, Typography } from 'antd';
import { Link } from 'react-router-dom';

import { api } from '@/lib/api';

interface DriverSource {
  url: string;
  title: string | null;
  date: string;
}

interface DriverChipProps {
  word: string;
  polarity: 'positive' | 'negative';
  brandId: string;
  week: string;
}

export default function DriverChip({ word, polarity, brandId, week }: DriverChipProps) {
  const [sources, setSources] = useState<DriverSource[] | null>(null);
  const [loading, setLoading] = useState(false);

  const palette =
    polarity === 'positive'
      ? { bg: '#DCFCE7', fg: '#15803D' }
      : { bg: '#FEE2E2', fg: '#991B1B' };

  const fetchSources = async () => {
    if (sources !== null) return; // 只拉一次
    setLoading(true);
    try {
      const { data } = await api.get<{ sources: DriverSource[] }>(
        `/brands/${brandId}/driver-sources`,
        { params: { week, driver: word, polarity, limit: 5 } },
      );
      setSources(data.sources ?? []);
    } catch {
      setSources([]);
    } finally {
      setLoading(false);
    }
  };

  const content = loading ? (
    <div className="py-2 px-3">
      <Spin size="small" /> <span className="text-[12px] text-slate-500 ml-2">加载中…</span>
    </div>
  ) : sources && sources.length > 0 ? (
    <List
      size="small"
      style={{ maxWidth: 320 }}
      dataSource={sources}
      renderItem={(item) => (
        <List.Item>
          <a
            href={item.url}
            target="_blank"
            rel="noopener noreferrer"
            className="text-blue-600 hover:underline text-[12px]"
          >
            {item.title || item.url}
          </a>
        </List.Item>
      )}
    />
  ) : (
    // 空 → fallback B(brand only,不加 q filter)
    <Link to={`/complaints?brand=${brandId}`} className="text-[12px] text-blue-600 hover:underline">
      <Typography.Text className="text-[12px]">暂无相关原文链接,跳投诉页 →</Typography.Text>
    </Link>
  );

  return (
    <Popover
      trigger="click"
      onOpenChange={(open) => {
        if (open) void fetchSources();
      }}
      content={content}
    >
      <button
        type="button"
        className="inline-flex items-center rounded-full font-medium text-[12px] px-2.5 py-1 cursor-pointer hover:opacity-80"
        style={{ background: palette.bg, color: palette.fg }}
      >
        {word}
      </button>
    </Popover>
  );
}
